/**
 * Token / 用户信息持久化封装。
 * access/refresh token 只存 sessionStorage，避免浏览器重启后长期暴露。
 */

const TOKEN_KEY = 'poet.accessToken';
const REFRESH_KEY = 'poet.refreshToken';
const USER_KEY = 'poet.user';
const LAST_ACTIVITY_KEY = 'poet.lastActivityAt';

/** 闲置超时：连续无用户操作超过该时长，会话即失效需重新登录（单位 ms）。 */
export const IDLE_TIMEOUT_MS = 60 * 60 * 1000; // 60 分钟

/** 最近一次用户操作时间戳（ms）。0 表示未记录。 */
export function getLastActivity(): number {
  const raw = localStorage.getItem(LAST_ACTIVITY_KEY);
  return raw ? Number(raw) || 0 : 0;
}

export function setLastActivity(ts: number): void {
  localStorage.setItem(LAST_ACTIVITY_KEY, String(ts));
}

export interface StoredUser {
  id: string;
  name: string;
  role: 'admin' | 'teacher' | 'student' | 'assistant';
  phone?: string | null;
  studentNo?: string | null;
  employeeNo?: string | null;
  avatarUrl?: string | null;
}

export function getAccessToken(): string | null {
  return sessionStorage.getItem(TOKEN_KEY);
}

export function getRefreshToken(): string | null {
  return sessionStorage.getItem(REFRESH_KEY);
}

export function getStoredUser(): StoredUser | null {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as StoredUser;
  } catch {
    return null;
  }
}

export function setAuth(opts: {
  accessToken: string;
  refreshToken: string;
  user: StoredUser;
}): void {
  sessionStorage.setItem(TOKEN_KEY, opts.accessToken);
  sessionStorage.setItem(REFRESH_KEY, opts.refreshToken);
  localStorage.setItem(USER_KEY, JSON.stringify(opts.user));
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_KEY);
}

export function updateAccessToken(token: string): void {
  sessionStorage.setItem(TOKEN_KEY, token);
  localStorage.removeItem(TOKEN_KEY);
}

export function clearAuth(): void {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(LAST_ACTIVITY_KEY);
}
